import { render } from "./clinicStatic.vue?vue&type=template&id=67520a1a&scoped=true"
import script from "./clinicStatic.vue?vue&type=script&lang=js"
export * from "./clinicStatic.vue?vue&type=script&lang=js"

import "./clinicStatic.vue?vue&type=style&index=0&id=67520a1a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67520a1a"]])

export default __exports__